import { type TSize, type TOrientation } from "@/types/common";
import applyResponsiveStyles from "@/utils/applyResponsiveStyles";
import tw, { styled } from "twin.macro";

interface StyledProductCardGalleryXLSkeletonRootProps {
  $orientation: TOrientation;
  $size?: TSize;
}
const style = {
  root: {
    base: tw`border rounded-s`,
    orientation: {
      horizontal: {
        base: tw`flex flex-row`,
        size: {
          small: tw`min-w-[20rem] h-[12.938rem]`,
          medium: tw`w-[22.81.3rem] h-[13.625rem]`,
          large: tw`min-w-[26.25rem] h-[14.313rem]`,
        },
      },
      vertical: {
        base: tw`flex flex-col`,
        size: {
          small: tw`min-h-[23.938rem]`,
          medium: tw`min-h-[29.875rem]`,
          large: tw`min-h-[31.875rem]`,
        },
      },
    },
  },
};
export const StyledProductCardGalleryXLSkeletonRoot = styled.div<StyledProductCardGalleryXLSkeletonRootProps>`
  ${style.root.base}
  ${({ $orientation }) => style.root.orientation[$orientation].base}

  ${({ $size, $orientation }) =>
    applyResponsiveStyles({ stylesBreakpoints: style.root.orientation[$orientation].size, size: $size })}
`;

export const StyledSkeletonContentWrapper = styled.div`
  ${tw`flex flex-col justify-between px-m py-s h-full flex-1`}
`;

export const StyledSkeletonContent = styled.div`
  ${tw`flex flex-col gap-xxs border-b border-neutral-90 pb-xs`}
`;
